import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PessoaContato } from '../pessoa-contato';

@Component({
    selector: 'sgt-pessoa-contato-list-group',
    templateUrl: './pessoa-contato-list-group.component.html',
    styleUrls: ['./pessoa-contato-list-group.component.less']
})
export class PessoaContatoListGroupComponent {
    /** Contatos do pessoa */
    @Input() contatos: PessoaContato[] = [];
    /** Se pode abrir um contato */
    @Input() canOpen = true;
    /** Evento para abrir um contato */
    @Output() open = new EventEmitter<PessoaContato>();
    /** Tamanho da fonte dos textos de contato */
    @Input() fontSize = '10px';

    openClick(contato: PessoaContato) {
        if (!this.canOpen) {
            return;
        }
        this.open.emit(contato);
    }
}
